<template>
  <div v-if="!$isInIframe && isReplenishmentPage" class="text-white font-bold p-0 bg-pdsPrimaryColor">
    <div class="ml-auto w-11/12 pb-2">
      <div class="justify-items-end place-content-center space-x-2 mr-12 col-span-2">
        <div class="flex justify-end place-content-end items-start md:items-end self-start flex-wrap flex-row">
          <v-cart class="mr-2" />
        </div>
      </div>
    </div>
  </div>
  <page-header v-if="isReplenishmentFlow">
    <template v-slot:title> Magazijn aanvullen </template>
  </page-header>
  <div v-if="isReplenishmentFlow" class="depot-material-card -mt-32">
    <div class="mx-auto w-10/12 pb-12 min-h-screen">
      <div class="rounded-lg py-6">
        <div class="grid grid-col-12 pb-8">
          <card>
            <template v-slot>
              <div class="pt-4 pb-6">
                <!-- <label for="txtSearchPump" class="block leading-6 text-black font-bold text-base">Zoek pomp</label> -->
                <div class="grid grid-cols-2 my-2">
                  <div class="col-span-2">
                    <div class="flex">
                      <div id="materialSearch" class="ml-32 col-xs-12 col-sm-9">
                        <v-input-group-simple-2
                          id="depotMaterialSearch"
                          v-model:value="form.text"
                          :overwrite-value="form.text"
                          :rules="{
                            required: false
                          }"
                          placeholder="Zoeken naar producten"
                          @input="saveProductSearchText($event)"
                        />
                        <sync-loader v-if="loading" color="#73c8d2" size="8px" class="absolute top-3.5 right-4" />
                        <MagnifyingGlassIcon
                          v-else
                          class="h-5 w-5 inline-block text-pdsPrimaryColor cursor-pointer absolute top-3.5 right-4"
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="text-2xl font-semibold leading-6 flex-1 mx-2">Producten</span>
              <v-search-products
                v-if="searchResults && searchResults.length > 0"
                :search-products="searchResults"
                @load-more="loadMore()"
              />
              <div v-if="hasError === true" class="m-2">Er is een fout opgetreden.</div>
              <div v-else-if="searchResults == 0 && !loading" class="m-2">
                Geen producten gevonden met deze zoekterm.
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
  <section v-if="!isReplenishmentFlow" class="catalog mx-auto w-10/12 py-9">
    <div class="grid grid-rows gap-4 lg:grid-cols-4">
      <div class="col-span-4 lg:col-span-1">
        <form v-if="!isReplenishmentFlow">
          <div class="bg-white shadow rounded-lg py-6 border border-balternative-color">
            <div class="col-span-12 sm:col-span-3 px-6">
              <div v-if="isAssortmentFlow" class="row grid-margin catalog__assortiment">
                <div class="col-xs-12 col-sm-3">
                  <h1 class="text-pdsPrimaryColor text-2xl font-semibold mt-0">Assortiment</h1>
                </div>
                <div class="col-xs-12">
                  <div class="catalog__assortiment__alert-wrapper">
                    <v-info-outline-icon class="catalog__assortiment__alert-wrapper__infoIcon" />
                    Wilt u producten bestellen? Selecteer dan eerst een patiënt en maak een machtiging aan via
                    <router-link to="/"> Mijn Dashboard. </router-link>
                  </div>
                </div>
              </div>
              <h1 v-else class="text-pdsPrimaryColor text-2xl font-semibold mt-0">Product catalogus</h1>
            </div>
            <v-filters
              v-if="filters && filters.length > 0"
              v-model="form.filters"
              :filters="filters"
              @update:model-value="search"
            />
            <v-favourites
              v-if="favourites && favourites.length > 0"
              v-model="form.favorites"
              :favourites="favourites"
              :value="form.favorites"
              @update:model-value="search"
            />
            <v-categories
              v-if="categories.length !== 0 && activeDepartment"
              v-model="form.category"
              :categories="categories"
              @update:model-value="search"
            />
            <v-manufacturers
              v-if="manufacturers.length !== 0"
              v-model="form.manufacturers"
              :manufacturers="manufacturers"
              @update:model-value="search"
            />
            <v-favourites-edit-form :favourites="favourites" @close="closeOverlay" v-if="overlayActive" />
          </div>
        </form>
      </div>
      <div
        v-if="!isReplenishmentFlow"
        :class="!isReplenishmentFlow ? 'col-span-4 lg:col-span-3' : 'col-span-4'"
        class="overflow-hidden"
      >
        <div class="row align-items-center mb-4 mt-1">
          <div id="catalogSearch" class="relative w-full">
            <v-input-group-simple-2
              id="catalogProductSearch"
              v-model:value="form.text"
              :overwrite-value="form.text"
              :rules="{
                required: false
              }"
              placeholder="Zoeken naar producten"
              @input="saveProductSearchText($event)"
            />
            <sync-loader v-if="loading" color="#73c8d2" size="8px" class="absolute top-3.5 right-4" />
            <MagnifyingGlassIcon
              v-else
              class="h-5 w-5 inline-block text-pdsPrimaryColor cursor-pointer absolute top-3.5 right-4"
              aria-hidden="true"
            />
          </div>
          <div v-if="activeTokens.length > 0 && !isReplenishmentFlow" class="col-xs-12">
            <v-tokens :tokens="activeTokens" :result-count="totalProductCount" />
          </div>
        </div>
        <v-bundles
          v-if="!isProductTextSearch && bundles && bundles.length > 0 && isCustomerFlow"
          :bundles="bundles"
          class="col-span-4 md:col-span-3"
        />
        <v-products
          v-if="!isProductTextSearch && !showDepotMaterialsOnCatalog && searchResults && searchResults.length > 0"
          :base-products="searchResults"
          :favorite-selected="favoriteSelected"
          :favorite-BundleIds="favoriteBundleIds"
          @load-more="loadMore()"
          @reload-search="reloadSearch()"
        />
        <v-search-products
          v-if="(isProductTextSearch || showDepotMaterialsOnCatalog) && searchResults && searchResults.length > 0"
          :search-products="searchResults"
          :search-products-term="form.text"
          :assortment-flow="isAssortmentFlow"
          @load-more="loadMore()"
          @reload-search="reloadSearch()"
        />
        <div v-if="hasError === true">Er is een fout opgetreden.</div>
        <div v-else-if="searchResults == 0 && !loading">Geen producten gevonden met deze zoekterm.</div>
      </div>
    </div>
    <generic-modal v-if="showAssortimentPopUp && !catalogAssortimentStatus">
      <template #header> Assortiment </template>
      <template #body>
        <p>U kunt hier het hele assortiment bekijken en uw favoriete producten beheren.</p>
        <p>
          Wilt u een product bestellen? Selecteer dan eerst een patiënt en maak een nieuwe machtiging aan om producten
          te kunnen bestellen.
        </p>
      </template>
      <template #footer>
        <div class="flex pr-2.5">
          <v-checkbox-group
            v-model="assortimentRememberStatus"
            class="flex items-center"
            label="Laat dit bericht niet meer zien"
            :overwrite-value="assortimentRememberStatus"
            inputid="rememberAssortiment"
          />
        </div>
        <v-button tagelement="button" md primary @click="closeModal"> Naar assortiment </v-button>
      </template>
    </generic-modal>
  </section>
</template>

<script>
import VProducts from './Products';
import VSearchProducts from './searchProducts/SearchProducts';
import VFilters from './Filters';
import VFavourites from './Favourites';
import VManufacturers from './Manufacturers';
import VCategories from './categories/Categories';
import VTokens from './Tokens';
import VFavouritesEditForm from './FavouritesEditForm';
import VBundles from './Bundles';
import SyncLoader from 'vue-spinner/src/SyncLoader.vue';
import GenericModal from '@/components/shared/GenericModal';
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup';
import VInfoOutlineIcon from 'icons/InformationOutline';
import VCart from '@/components/sections/catalog/cart/Index';
import { Subject, from } from 'rxjs';
import { activeDepartment$, currentUserIdentity$ } from '@/services';
import {
  switchMap,
  refCount,
  publishReplay,
  map,
  concatMap,
  startWith,
  scan,
  publishBehavior,
  tap,
  catchError
} from 'rxjs/operators';
import axios from 'axios';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid';

const filterAccountableProducts = { label: 'Toon alleen gemachtigde', tokenLabel: 'Gemachtigde' };
const filterRecentOrderedProducts = { label: 'Eerder besteld voor patient', tokenLabel: 'Eerder besteld voor patient' };
const filterDepotMaterials = { label: 'Toon producten uit mijn depot', tokenLabel: 'Producten uit mijn depot' };

export default {
  name: 'Catalog',
  components: {
    VProducts,
    VSearchProducts,
    VFilters,
    VCategories,
    VTokens,
    VFavourites,
    VManufacturers,
    VFavouritesEditForm,
    VBundles,
    SyncLoader,
    GenericModal,
    VCheckboxGroup,
    VInfoOutlineIcon,
    MagnifyingGlassIcon,
    VCart
  },
  beforeRouteLeave(to, from, next) {
    if (!to.meta.catalogFilters) {
      this.resetCatalogFormDetails();
    }
    next();
  },
  setup() {
    const currentUserIdentity = ref(null);
    const store = useStore();
    const activeDepartment = ref(null);
    const loading = ref(null);
    const hasError = ref(null);
    const searchResults = ref(null);
    const totalProductCount = ref(null);
    const loadingSubject$ = new Subject();
    const router = useRouter();
    const filters = ref([]);
    const showAssortimentPopUp = ref(null);
    const productsRequestSubject$ = new Subject();
    const productsLoadMoreSubject$ = new Subject();
    const isReplenishmentPage = ref(false);

    const favorites = computed(() => store.getters['catalog/getFavorites']);
    const categories = computed(() => store.getters['catalog/getNewCategories']);
    const overlayActive = computed(() => store.getters['catalog/getOverlay']);
    const favourites = computed(() => store.getters['catalog/getFavoriteCategories']);
    const bundles = computed(() => store.getters['catalog/getBundles']);
    const catalogAssortimentStatus = computed(() => store.getters['catalog/getCatalogAssortiment']);
    const manufacturers = computed(() => store.getters['catalog/getManufacturers']);
    const form = computed(() => store.getters['catalog/getCatalogFormDetails']);
    const patientDetails = computed(() => store.getters['patient/getPatientGegevens']);
    const consignmentMaterialIds = computed(() => store.getters['navigation/getCTypeMaterialIds']);
    const depotMaterialIds = computed(() => store.getters['navigation/getFTypeMaterialIds']);

    const setRememberAssortiment = (value) => store.commit('catalog/setRememberAssortiment', value);
    const setOverlayActive = (value) => store.commit('catalog/setOverlayActive', value);
    const resetCatalogFormDetails = () => store.commit('catalog/resetCatalogFormDetails');

    const isReplenishmentFlow = computed(() => {
      return router.currentRoute.value.meta.flow === 'replenishment';
    });
    const isAssortmentFlow = router.currentRoute.value.meta.flow === 'assortment';
    const isCustomerFlow = router.currentRoute.value.meta.flow === 'customer';
    const isCTypeMaterialAvailable = store.state.navigation.cTypeMaterials;

    let currentPath = JSON.stringify(router.currentRoute.value.path);
    if (currentPath.includes('/aanvullenmagazijn')) {
      isReplenishmentPage.value = true;
    }

    if (store.state.navigation.siteCode !== 'MTF' && isCustomerFlow) {
      filters.value.push(filterAccountableProducts);
      filters.value.push(filterRecentOrderedProducts);
    }

    if (isCTypeMaterialAvailable) {
      filters.value.push(filterDepotMaterials);
    }

    if (!isReplenishmentFlow.value && !isAssortmentFlow) {
      store.dispatch('catalog/fetchBundles');
    }
    if (isAssortmentFlow) {
      showAssortimentPopUp.value = true;
    }

    if (!isReplenishmentFlow.value) {
      store.dispatch('catalog/fetchFilters');
      store.dispatch('catalog/fetchManufacturers');
      store.dispatch('catalog/fetchFavourites');
      store.dispatch('catalog/fetchCategories');
    }

    const fetchConsignmentMaterialList = () => {
      store.dispatch('navigation/fetchDepotMaterialDetails');
    };

    const searchResults$ = productsRequestSubject$.pipe(
      switchMap((request) =>
        productsLoadMoreSubject$.pipe(
          startWith(0),
          tap(() => {
            loadingSubject$.next(true);
          }),
          concatMap((_, pageNum) => {
            if (isReplenishmentFlow.value) {
              const url = request + 'pageIndex=' + (pageNum + 1);
              return from(axios.post(url)).pipe(
                catchError(() => {
                  return Promise.resolve({ data: { totalProducts: -1, error: true, products: [] } });
                }),
                map((r) => r.data)
              );
            } else {
              const url = request + '&pageIndex=' + (pageNum + 1);
              return from(axios.get(url)).pipe(
                catchError(() => {
                  return Promise.resolve({ data: { totalProducts: -1, error: true, products: [] } });
                }),
                map((r) => r.data)
              );
            }
          }),
          scan(
            (previous, p) => {
              if (!p) {
                return previous;
              }
              return {
                totalProducts: p.totalProducts,
                error: p.error,
                products: [
                  ...previous.products,
                  ...p.products.map((product) => Object.assign(product, { isExpanded: false }))
                ]
              };
            },
            { totalProducts: 0, products: [] }
          ),
          tap(() => loadingSubject$.next(false)),
          publishBehavior({
            totalProducts: -1,
            error: false,
            products: []
          }) /* initial value: e.g. at startup and when filters/categories/text change occur */,
          refCount()
        )
      ),
      publishReplay(1),
      refCount()
    );

    activeDepartment$.subscribe((value) => (activeDepartment.value = value));
    loadingSubject$.asObservable().subscribe((value) => (loading.value = value));
    searchResults$.pipe(map((r) => r.error)).subscribe((value) => (hasError.value = value));
    searchResults$.pipe(map((r) => r.products)).subscribe((value) => (searchResults.value = value));
    searchResults$.pipe(map((r) => r.totalProducts)).subscribe((value) => (totalProductCount.value = value));
    currentUserIdentity$.subscribe((value) => {
      currentUserIdentity.value = value;
    });

    return {
      currentUserIdentity,
      favorites,
      categories,
      overlayActive,
      favourites,
      bundles,
      catalogAssortimentStatus,
      manufacturers,
      form,
      patientDetails,
      setRememberAssortiment,
      setOverlayActive,
      resetCatalogFormDetails,
      activeDepartment,
      loading,
      hasError,
      searchResults,
      totalProductCount,
      isReplenishmentFlow,
      isAssortmentFlow,
      isCustomerFlow,
      filters,
      showAssortimentPopUp,
      consignmentMaterialIds,
      depotMaterialIds,
      fetchConsignmentMaterialList,
      productsRequestSubject$,
      productsLoadMoreSubject$,
      isReplenishmentPage
    };
  },
  data() {
    return {
      productSearchTextTimer: null,
      assortimentRememberStatus: false,
      filteredCategories: [],
      showDepotMaterialsOnCatalog: false,
      favoriteSelected: false,
      favoriteBundleIds: []
    };
  },
  computed: {
    filteredCategoryList() {
      if (this.form.filters.length > 0) {
        return this.filteredCategories;
      } else {
        return this.categories;
      }
    },
    isProductTextSearch() {
      return !!this.form.text;
    },
    activeTokens() {
      const result = [];

      if (this.form.text) {
        result.push({
          label: 'Zoekterm: ' + this.form.text,
          remove: () => {
            this.form.text = null;
            this.search();
          }
        });
      }

      if (this.form.filters.length > 0) {
        this.form.filters.forEach((filter, index) => {
          result.push({
            label: filter.tokenLabel,
            remove: () => {
              this.form.filters.splice(index, 1);
              this.search();
            }
          });
        });
      }

      if (this.form.favorites.length > 0) {
        this.form.favorites.forEach((favorite, index) => {
          result.push({
            label: 'Favoriet: ' + favorite.name,
            remove: () => {
              this.form.favorites.splice(index, 1);
              this.search();
            }
          });
        });
      }

      if (this.form.manufacturers.length > 0) {
        this.form.manufacturers.forEach((manufacturer, index) => {
          result.push({
            label: 'Fabrikant: ' + manufacturer,
            remove: () => {
              this.form.manufacturers.splice(index, 1);
              this.search();
            }
          });
        });
      }

      if (this.form.category) {
        result.push({
          label: this.activeDepartment ? this.form.category.description : this.form.category.omschrijving,
          remove: () => {
            this.form.category = null;
            this.search();
          }
        });
      }

      return result;
    }
  },
  watch: {
    'form.filters': {
      handler(newFilters, oldFilters) {
        if (!this.isAssortmentFlow) {
          this.categories = this.categories.filter((obj) =>
            this.currentUserIdentity.userTreatmentArea.map((area) => area.treatmentAreaId).includes(obj.treatmentAreaId)
          );
        }

        if (newFilters.length > 0 && newFilters.includes(filterAccountableProducts)) {
          this.filteredCategories = this.categories.filter((obj) =>
            this.store.state.patient.patientGegevens.TreatmentAreas.includes(obj.treatmentAreaId)
          );
        } else {
          this.filteredCategories = this.categories;
        }
      },
      immediate: true
    },
    isReplenishmentFlow(value) {
      if (value) {
        this.form.text = null;
        this.search();
      }
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      const isRecentOrderFilter = this.form.filters.find(
        (filter) => JSON.stringify(filter) === JSON.stringify(filterRecentOrderedProducts)
      );
      // Build xhr request
      // Note: Search functionality requires additional refactoring.
      // Note 2: When replenishment flow is active this search url will not be used, instead the subject will trigger replenishment xhr request within the observable (see `subscriptions`).
      let apiCall =
        this.isProductTextSearch || this.form.filters.includes(filterDepotMaterials) || isRecentOrderFilter
          ? 'Catalogue/SearchProductFromCatalogue'
          : 'Catalogue/GetBaseProducts';

      this.favoriteSelected = false;
      // let apiCall = this.isProductTextSearch
      //   ? 'Products/Search'
      //   : 'Products/GetBaseProducts';

      apiCall += this.isAssortmentFlow ? '?ignoreCustomer=true' : '?ignoreCustomer=false';

      apiCall += this.isAssortmentFlow ? '&customerId=null' : '&customerId=' + this.patientDetails.PatientId;

      if (this.isProductTextSearch || isRecentOrderFilter) {
        apiCall += '&term=' + encodeURIComponent(this.form.text || '');
      }

      if (this.form.filters.includes(filterAccountableProducts)) {
        apiCall += '&IsLicensed=true';
      }

      if (isRecentOrderFilter) {
        apiCall += '&RecentOrders=true';
      }

      if (this.form.favorites.length > 0) {
        this.favoriteSelected = true;
        this.form.favorites.forEach((favorite) => {
          this.favoriteBundleIds.push(favorite.bundleId);
          apiCall += '&BundleIdList=' + favorite.bundleId;
        });
      }

      if (this.form.manufacturers.length > 0) {
        this.form.manufacturers.forEach((manufacturer) => {
          apiCall += '&manufacturer=' + manufacturer;
        });
      }

      if (this.form.category) {
        let groupIds = this.activeDepartment ? this.form.category.nestedCategoryIds : this.form.category.productGroepId;
        groupIds.forEach((groupId) => {
          apiCall += '&CategoryIdList=' + groupId;
        });
      }

      if (this.form.filters.includes(filterDepotMaterials)) {
        this.showDepotMaterialsOnCatalog = true;
        apiCall += '&IsDepotMaterial=true';
      } else if (!this.isReplenishmentFlow) {
        apiCall += '&consignmentMaterialIds=' + this.consignmentMaterialIds;
        this.showDepotMaterialsOnCatalog = false;
      }

      if (this.isReplenishmentFlow) {
        if (this.depotMaterialIds === null || (this.depotMaterialIds !== null && this.depotMaterialIds.length === 0)) {
          this.fetchConsignmentMaterialList();
        }
        this.isProductTextSearch = true;
        apiCall = 'Products/GetDepotMaterialsFromSap';
        if (this.form.text !== null)
          apiCall +=
            '?searchText=' + encodeURIComponent(this.form.text) + '&depotMaterialIds=' + this.depotMaterialIds + '&';
        else apiCall += '?depotMaterialIds=' + this.depotMaterialIds + '&';
      }

      this.productsRequestSubject$.next(apiCall);
      return;
    },
    loadMore() {
      this.productsLoadMoreSubject$.next(true); // just move to next pageIndex, no need to pass index as it is handled within pipe.
    },
    closeModal() {
      this.showAssortimentPopUp = false;
      this.setRememberAssortiment(this.assortimentRememberStatus);
    },
    closeOverlay() {
      this.setOverlayActive(false);
    },
    saveProductSearchText(event) {
      if (this.productSearchTextTimer) {
        clearTimeout(this.productSearchTextTimer);
      }
      const text = event.target.value;
      this.productSearchTextTimer = setTimeout(() => {
        if (text.length >= 3) {
          this.form.text = text;
        } else {
          this.form.text = null;
        }

        this.search();
      }, 300);
    },
    getVisibilityStatus() {
      return !this.isReplenishmentFlow;
    },
    reloadSearch() {
      this.search();
    }
  }
};
</script>
<style land="css">
.catalog .overlay > div {
  max-width: 800px;
}
</style>
<style lang="scss" scoped>
.depot-material-card {
  color: $teal-darkest;
  :deep(.form-group-simple label) {
    color: $black;
    font-weight: 700;
    font-size: 16px;
  }
}
.catalog {
  &__assortiment {
    fill: $smooth-blue;
    color: $smooth-blue;
    font-size: 15px;
    &__alert-wrapper {
      background-color: $lightest-blue;
      padding: 15px;
      font-style: italic;
      .material-design-icon {
        fill: $smooth-blue !important;
        display: inline-block;
        vertical-align: middle;
      }
      a {
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}
</style>
